import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_AUTORIZADOR_PORT}${process.env.VUE_APP_API_PATH}/autorizadorfinanceiro`;

const urlBase = `${api}/borderos`;

export default {
    visualizar(lancamentoId) {
        return axiosJwt.post(`${urlBase}/lancamentos/${lancamentoId}/visualizar`);
    },

    obterArquivoLancamento(lancamentoId) {
        return axiosJwt.get(`${urlBase}/lancamentos/${lancamentoId}/arquivo`, {
            responseType: 'blob',
        });
    },
};
